import React from 'react';
import style from './flightPlanTrack.module.scss';

interface FlightPlanProps {
    className?: string;
    desktopFlightPlan: React.ReactNode;
    mobileFlightPlan: React.ReactNode;
}

export class FlightPlan extends React.Component<FlightPlanProps> {
    render(): JSX.Element {
        return (
            <div className={this.props.className}>
                <div className={style.DesktopView}>
                    {this.props.desktopFlightPlan}
                </div>
                <div className={style.MobileView}>
                    {this.props.mobileFlightPlan}
                </div>
            </div>
        );
    }
}
